import {validateEmail} from './validateEmail';
import {checkEmptyFields} from './checkEmptyFields';

export const checkFormField = ( field ) => {
	const form = field.closest( 'form' );
	
	field.closest( 'li.empty' ) ? field.closest( 'li.empty' ).classList.remove( 'empty' ) : false;
	field.closest( 'li.invalid' ) ? field.closest( 'li.invalid' ).classList.remove( 'invalid' ) : false;
	
	if ( field.hasAttribute( 'disabled' ) )
	{
		return;
	}

	if ( !form.classList.contains( 'on' ) )
	{
		form.addEventListener( 'keyup', ( evtKeyUp ) => evtKeyUp.target.getAttribute( 'data-required') === 'yes' ? checkFormField( evtKeyUp.target ) : false );
		form.addEventListener( 'change', ( evtChange ) => evtChange.target.getAttribute( 'data-required' ) === 'yes' ? checkFormField( evtChange.target ) : false );
		form.classList.add( 'on' );
	}
	
	const val = field.value;
	const type = field.getAttribute( 'data-type' );

	if ( type )
	{
		if ( type === 'email' )
		{
			if ( val.length < 1 || !validateEmail( val ) )
			{
				field.closest( 'li' ).classList.add( 'invalid' );
			}
		}

		if ( type === 'checkbox' )
		{
			if ( !field.checked )
			{
				field.closest( 'li' ).classList.add( 'invalid' );
			}
		}

		if ( type === 'phone' )
		{
			if ( !/^[0-9\+\s\(\)\-]{5,20}$/.test( val ) )
			{
				field.closest( 'li' ).classList.add( 'invalid' );
			}
		}

		if ( type === 'file' && val === '' )
		{
			field.closest( 'li' ).classList.add( 'invalid' );
		}

		if ( type === 'phone-or-email' )
		{
			if ( ( val.length < 1 || !validateEmail( val ) ) && !/^[0-9\+\s\(\)\-]{5,20}$/.test( val ) )
			{
				field.closest( 'li' ).classList.add( 'invalid' );
			}
		}

		if ( type === 'radios' )
		{
			if ( !field.form.querySelector( `input[name="${field.name}"]:checked` ) )
			{
				field.closest( 'ul.fields > li' ).classList.add( 'invalid' );
			}
		}

		if ( type === 'date' )
		{
			if ( val.replace( /\D+/g, '' ).length < 8 )
			{
				field.closest( 'ul.fields > li' ).classList.add( 'invalid' );
			}
		}

	}
	else
	{
		if ( val.length < 1 )
		{
			field.closest( 'li' ).classList.add( 'invalid' );
		}
	}

	if ( field.dataset.invalidMessage && field.closest( 'li' ).classList.contains( 'invalid' ) && !field.closest( 'li' ).querySelector( 'p.error' ) )
	{
		field.closest( 'li' ).insertAdjacentHTML( 'beforeend', `<p class="error">${field.dataset.invalidMessage}</p>` );
	}

	checkEmptyFields( field );
};
